import { Component } from '@angular/core'
@Component({
  selector: 'app-chat-analyzer',
  templateUrl: './chat-analyzer-page.component.html',
  styleUrls: [`./chat-analyzer-page.component.scss`],
})
export class ChatAnalyzerComponent {}
